import React from 'react';

import style from './intro.module.scss';

export const Intro = () => {
    return (
        <div className={style.intro}>
            <div className={style.introContent}>
                <div className={style.introTitle}>
                    <p>
                        Committed to Sealing Your Success
                    </p>
                </div>

                <div className={style.introText}>
                    Wintech seals is a leading supplier of specialized sealing solutions and performance rubber and
                    plastic components. Since our foundation in 2008, we have been focused on providing value to our
                    customers through reliable products and services, application expertise, and constant innovation. We
                    take a consultative approach to solving our customers most challenging problems. We provide
                    consistent, reliable service coupled with product and industry expertise to build great partnerships
                    and help our customers seal their success.
                </div>
            </div>
        </div>
    );
};
